import './NotificationPopup.less';

import React, { FC } from 'react';
import CloseIcon from '../../../icons/CloseIcon';
import TournamentIcon from '../../../icons/TournamentIcon';
import i18n from '../../../common/i18n';

interface NotifcationPopupProps {
    onClick: () => void;
    onCloseAction: () => void;
    active: boolean;
}

interface CloseButtonProps {
    CloseAction: () => void;
}

const CloseButton: FC<CloseButtonProps> = ({ CloseAction }) => (
    <div className="notification-popup-close flex p-abs pointer" onClick={CloseAction}>
        <CloseIcon />
    </div>
);

const NotificationPopup: FC<NotifcationPopupProps> = ({ onClick, onCloseAction, active }) => {
    return (
        <div className="nui-notification-popup-holder flex mx-20 p-rel">
            <div className="nui-notification-popup flex pointer" onClick={onClick}>
                <div className="notification-popup-box">
                    <div className="notification-popup-content flex flex-col pl-10 pt-10">
                        <div className="notification-popup-title flex fs-16 text-bold uppercase pb-5">
                            {i18n(active ? 'nui.NotificationPopup.active.title' : 'nui.NotificationPopup.title')}
                        </div>
                        <div className="flex items-center">
                            <div className="notification-popup-text flex fs-14">
                                {i18n(active ? 'nui.NotificationPopup.active.text' : 'nui.NotificationPopup.text')}
                            </div>
                            <div className="notification-popup-icon flex px-15">
                                <TournamentIcon />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="notification-popup-progress p-abs flex full-width">
                    <div className="notification-popup-progress-bar flex" />
                </div>
            </div>
            <CloseButton CloseAction={onCloseAction} />
        </div>
    );
};
export default NotificationPopup;
